import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex flex-col items-center justify-center bg-slate-950/60 backdrop-blur-md"
}
const _hoisted_2 = { class: "w-full max-w-md px-8 text-center" }
const _hoisted_3 = { class: "mb-6 inline-flex h-20 w-20 items-center justify-center rounded-3xl bg-white/10 text-white shadow-2xl ring-1 ring-white/20" }
const _hoisted_4 = { class: "relative h-4 overflow-hidden rounded-full bg-slate-800/50 p-1 shadow-inner ring-1 ring-white/10" }
const _hoisted_5 = { class: "mt-3 text-right font-mono text-sm font-medium text-sky-400" }
const _hoisted_6 = { class: "flex min-h-screen flex-col" }
const _hoisted_7 = { class: "mx-auto flex w-full max-w-4xl flex-col items-center gap-3 md:gap-4" }
const _hoisted_8 = { class: "w-full rounded-[2rem] border border-white/70 bg-white/75 p-4 shadow-[0_30px_80px_rgba(15,23,42,0.16)] ring-1 ring-slate-200/80 backdrop-blur" }
const _hoisted_9 = { class: "z-20 w-full rounded-[2.5rem] bg-gradient-to-t from-mist-100/95 via-mist-100/75 to-transparent pt-2 md:pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_Cell = _resolveComponent("Cell")!
  const _component_Tools = _resolveComponent("Tools")!
  const _component_GitHubFooter = _resolveComponent("GitHubFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.show_search)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-30 flex items-start justify-center bg-slate-950/40 px-4 py-6 backdrop-blur-sm sm:py-10",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hideSearch && _ctx.hideSearch(...args)), ["self"]))
            }, [
              _createVNode(_component_Search)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.downloading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_ion_icon, {
                    class: "animate-pulse text-4xl",
                    name: "image-outline"
                  })
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "mb-2 text-2xl font-bold text-white" }, "Preparing image...", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-slate-300" }, "Processing images.", -1)),
                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mb-8 text-slate-300" }, "This may take a minute.", -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "h-full rounded-full bg-gradient-to-r from-sky-400 via-blue-400 to-cyan-300",
                    style: _normalizeStyle({ width: `${_ctx.progress}%` })
                  }, null, 4)
                ]),
                _createElementVNode("div", _hoisted_5, _toDisplayString(Math.round(_ctx.progress)) + "% ", 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("main", {
        class: "flex-1 px-4 pb-6 pt-6 sm:px-6 sm:pb-8 lg:px-8",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideForm && _ctx.hideForm(...args)))
      }, [
        _createElementVNode("section", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              id: "grid",
              class: "mx-auto grid w-full max-w-2xl gap-0 overflow-hidden rounded-[1.5rem] bg-slate-200/70 shadow-inner",
              style: _normalizeStyle(_ctx.gridStyle)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiles, (n) => {
                return (_openBlock(), _createBlock(_component_Cell, {
                  id: n,
                  key: n,
                  class: _normalizeClass(["image", { selected: n === _ctx.selected_id }]),
                  style: _normalizeStyle({ boxShadow: '0px 0px 0px 1px ' + (n === _ctx.selected_id ? _ctx.complementary_color : _ctx.color) })
                }, null, 8, ["id", "class", "style"]))
              }), 128))
            ], 4)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Tools)
          ]),
          _createVNode(_component_GitHubFooter)
        ])
      ])
    ])
  ], 64))
}